import React from 'react';

import CardProfile from './containers/CardProfile';

import './style/App.css';

const App = () => <CardProfile />;

export default App;
